import { Reducer } from "redux";

import { get404InitialData } from "../utils";
import { BenefitPlanDetailsMasterActionDispatchTypes } from "../constants/Master";
import { BenefitPlanDetailsMasterResponse } from "../models/Api/Master";
import { BenefitPlanDetailsDispatchTypes } from "../models/DispatchTypes/Patient";

export const initialState: BenefitPlanDetailsMasterResponse = {
  loading: false,
  response: [],
};

const BenefitPlanDetailsReducer: Reducer<
  BenefitPlanDetailsMasterResponse,
  BenefitPlanDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case BenefitPlanDetailsMasterActionDispatchTypes.BENEFIT_PLAN_DETAILS_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case BenefitPlanDetailsMasterActionDispatchTypes.BENEFIT_PLAN_DETAILS_MASTER_SUCCESS: {
      return {
        ...state,
        response: get404InitialData(action.response, []),
        loading: false,
      };
    }
    case BenefitPlanDetailsMasterActionDispatchTypes.BENEFIT_PLAN_DETAILS_MASTER_RESET: {
      return initialState;
    }
    case BenefitPlanDetailsMasterActionDispatchTypes.BENEFIT_PLAN_DETAILS_MASTER_ERROR: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default BenefitPlanDetailsReducer;
